import React from 'react';
import { Link } from 'react-router-dom';

const Logo = ({ className = '' }) => {
  return (
    <Link 
      to="/" 
      className={`flex items-center space-x-2 text-primary-600 ${className}`}
      aria-label="Auto Kosmetyka - strona główna"
    >
      <svg
        className="w-8 h-8"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M3 9C3 6.23858 5.23858 4 8 4H16C18.7614 4 21 6.23858 21 9V15C21 17.7614 18.7614 20 16 20H8C5.23858 20 3 17.7614 3 15V9Z"
          stroke="currentColor"
          strokeWidth="2"
        />
        <path
          d="M7 8L12 12L17 8"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
        />
      </svg>
      <span className="text-xl font-display font-bold">Auto Kosmetyka</span>
    </Link>
  );
};

export default Logo;
